/**
 * Use case pour s'abonner en temps réel aux posts à proximité
 * Sert de pont entre l'infrastructure Firebase et le domaine
 */
import { GEO } from '../../../core/constants/geo';

export default class SubscribeToNearbyPosts {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  /**
   * Établit un abonnement temps réel aux posts à proximité
   * @param {Object} options 
   * @param {Object} options.center - Coordonnées du centre {latitude, longitude}
   * @param {number} options.radiusInKm - Rayon de recherche en kilomètres
   * @param {number} options.limit - Nombre maximum de résultats
   * @param {string} options.excludeUserId - ID de l'utilisateur à exclure
   * @param {Function} options.onUpdate - Callback appelé quand les posts sont mis à jour
   * @param {Function} options.onError - Callback appelé en cas d'erreur
   * @returns {Function} - Fonction pour désabonner
   */
  async execute({ center, radiusInKm = GEO.DEFAULT_RADIUS_KM, limit = 20, excludeUserId, onUpdate, onError }) {
    try {
      if (!center || !center.latitude || !center.longitude) {
        throw new Error('center coordinates are required');
      }

      // Utiliser le repository pour s'abonner aux posts à proximité
      const unsubscribe = await this.postRepository.subscribeToNearbyPosts({
        center,
        radiusInKm,
        limit,
        excludeUserId,
        onUpdate,
        onError
      });

      return unsubscribe;
    } catch (error) {
      onError(error);
      return () => {}; // Return empty unsubscribe function
    }
  }
} 